<template>
	<div 
	class="form-group" 
	:class="formGroupClass">
		<form-label 
		v-if="label" 
		:for="id">
			{{label}}
		</form-label>
		
		<input-group 
		ref="search" 
		prepend-icon="geo-alt"
		:value="place"
		:class="autocomplete_open ? 'is-open' : ''" 
		v-bind="$attrs" 
		@focusout="autocomplete_open = false" />

		<form-errors v-bind="{errors}" />

	</div>
</template>

<script>

	import {Loader, LoaderOptions} from 'google-maps'

	export default {

		props: {

			id: {
				type: String,
				default() {
					return `input-place-${this._uid}`
				},
			},

			formGroupClass: {
				type: [String, Array],
				default: ''
			},
			
			errors: {
  				type: String,
 				default: "",
  			},

			type: String,
			label: String,
			value: [String, Object, Array],
			sublabel: String,
		},

		data() {
			return {
				autocomplete_open: false
			};
		},

		computed: {

			place() {
				var value = this.value
				return value ? value.address : ''
			}

		},

		async mounted() {

			var input = this.$refs.search.$refs.input

			var options = this.type == 'city' ? {
				types: ['(cities)']
			} : null;

			setTimeout(() => {

				this.autocomplete = new google.maps.places.Autocomplete(
					input, options
				);
			
				this.autocomplete.addListener('place_changed', () => {

					var place = this.autocomplete.getPlace();
					this.autocomplete_open = false

					this.$emit('input', {
						name: place.name,
						address: place.formatted_address,
						place_id: place.place_id,
					})

				});

			}, 1000)

		}
	}
</script>